import type { ReactElement } from 'react'

import { IntervaloDatas } from './components/intervalo-datas'
import { PRESETS, ROTULO_PRESET, type Preset } from './types'

import { cn } from '@/lib/cn'

export interface SeletorPeriodoApresentacaoProps {
  preset?: Preset
  inicio?: string
  fim?: string
  onPreset: (preset: Preset) => void
  onIntervalo: (inicio: string, fim: string) => void
}

/** Troca de período (presets ou intervalo livre) direto no telão. */
export function SeletorPeriodoApresentacao({
  preset,
  inicio,
  fim,
  onPreset,
  onIntervalo,
}: SeletorPeriodoApresentacaoProps): ReactElement {
  return (
    <div className="flex flex-wrap items-center gap-2">
      <div
        role="group"
        aria-label="Período"
        className="border-border bg-card/70 flex flex-wrap items-center gap-1 rounded-full border p-1"
      >
        {PRESETS.map((p) => {
          const ativo = preset === p
          return (
            <button
              key={p}
              type="button"
              onClick={() => onPreset(p)}
              aria-pressed={ativo}
              className={cn(
                'min-h-[44px] rounded-full px-3 text-sm font-medium transition-colors sm:min-h-9',
                ativo
                  ? 'bg-primary text-primary-foreground'
                  : 'text-muted-foreground hover:text-foreground',
              )}
            >
              {ROTULO_PRESET[p]}
            </button>
          )
        })}
      </div>
      <IntervaloDatas inicio={inicio} fim={fim} onAplicar={onIntervalo} />
    </div>
  )
}
